<template>
    <div class="question-message">
        <TopBar/>
        <div class="content">
            <img src="../../assets/img/question_message.png" alt="课程不见了">
            <p>同学，暂无题库信息<span @click="logoutLoginFun">切换账号</span></p>
        </div>
    </div>
</template>

<script>
    import TopBar from "../../components/common/TopBar"

    export default {
        name: "QuestionMessage",
        data() {
            return {}
        },
        components: {
            TopBar
        },
        methods: {
            logoutLoginFun() {
                localStorage.clear();
                this.$router.push('/login');
                this.$message.success("退出成功！")
            }
        }
    }
</script>

<style lang="scss" scoped>
    .question-message {
        width: 100%;
        height: 100%;
        position: relative;
        .content {
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translate(-50%);
            img {
                width: 215px;
                font-size: 0;
                display: block;
            }
            p {
                text-align: center;
                font-size: 16px;
                padding-top: 24px;
                color: #999999;
                span {
                    margin-left: 5px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3D89FB;
                    cursor: pointer;
                }
            }
        }
    }
</style>
